export default __webpack_public_path__ + "static/media/business-contiunity.0fc7853d.png";